import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesComponent implements OnInit {
  @Input()
  public header = '';
  @Input()
  public body = '';

  isOpen = false;

  constructor() {}

  ngOnInit() {
    this.isOpen = false;
  }

  toggleBody() {
    if (this.body) {
      this.isOpen = !this.isOpen;
    }
  }
}
